import { isMobileApp } from "@/shared/mobileHelper";
import { fileHelper } from "@/shared/nativePlugins";
import moment from "moment";

export function downloadCsvFile (reportData: any, fileName: string): void {
  const csvData = new Blob([reportData], {type: "text/csv;charset=utf-8;"});
  let csvURL = null;
  if (navigator.msSaveBlob) {
    csvURL = navigator.msSaveBlob(csvData, fileName);
  } else {
    csvURL = window.URL.createObjectURL(csvData);
  }
  const tempLink = document.createElement("a");
  tempLink.href = csvURL;
  tempLink.setAttribute("download", fileName);
  document.body.appendChild(tempLink);
  tempLink.click();
  document.body.removeChild(tempLink);
  window.URL.revokeObjectURL(csvURL);
}

export async function downloadFromUrl (url: string, fileName?: string) {
  let resolvedFileName = fileName;
  if (resolvedFileName === null || resolvedFileName === undefined) {
    resolvedFileName = resolveFileNameFromUrlOrGetDefault(url);
  }

  if (isMobileApp()) {
    await fileHelper.downloadFile({ url });
  } else {
    const response = await fetch(url);
    const blob = await response.blob();
    const tempLink = document.createElement("a");

    tempLink.href = window.URL.createObjectURL(blob);
    tempLink.setAttribute("download", resolvedFileName);
    tempLink.target = "_blank";
    tempLink.click();

    window.URL.revokeObjectURL(tempLink.href);
  }
}

const resolveFileNameFromUrlOrGetDefault = (url: string) => {
  const pathName = new URL(url).pathname;
  const urlName = pathName.split("/").pop()?.split("?")[0];
  if (urlName && urlName.includes(".")) {
    return urlName;
  }

  return `file_downloaded_${moment().format("MMDDYYYY")}`;
};
